import styled from 'styled-components';
import { BaseMarginComponent } from '../../../common/base-margin/base-margin.component';
import { FlexContainer } from '../../../common/flex-container/flex-container.styles';
import { ServicesSubSectionContainer } from '../../services/services-subsection/services-subsection.styles';
import {
  CustomRadio,
  RadioDescription,
  RadioLabel,
} from '../../../common/radio/radio.styles';
import { FontSizes } from '../../../common/typography/typography.styles';
import { SidebarContainer } from '../../../common/info-select-with-sidebar/info-select-with-sidebar.styles';

export const PriceInput = styled.div`
  width: 100%;
`;

export const MarginContainer = styled(BaseMarginComponent('div'))`
  button {
    max-width: 160px;
  }
  button:not(:last-of-type) {
    margin-right: 2.4rem;
  }
`;

export const Header = styled(FlexContainer)`
  min-height: 32px;
  align-items: center;
`;

export const CustomHeader = styled.span`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0 !important;
`;

export const Content = styled.div`
  --grid-container-gap: 0.4rem;

  display: grid;
  gap: 1.6rem;
  margin-top: 1.6rem;

  @media (min-width: 768px) {
    --grid-container-gap: 1.6rem;
    gap: 2.2rem;
    margin-top: 2.4rem;
  }
`;

export const InsuranceFeeCoverageContainer = styled(
  ServicesSubSectionContainer
)`
  ${RadioLabel} {
    align-items: start;
  }

  ${RadioDescription} {
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.baseColors.grey100};
  }
  ${CustomRadio} {
    margin-top: 2px;
  }

  ${SidebarContainer} {
    margin-top: 2.4rem;
  }
`;

export const FullInsuranceTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 9px;
`;

export const InsuranceRadioDescription = styled(RadioDescription)`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 650px) {
    gap: 0.8rem;
  }
`;

export const InsuredValueInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (max-width: 650px) {
    gap: 0.8rem;
  }
`;

export const InsuredValueInputControl = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.2rem;
  width: 100%;

  @media (max-width: 650px) {
    align-items: stretch;
    flex-direction: column;
    gap: 0.6rem;
  }
`;

export const InsuredValueButtonContainer = styled.div`
  flex: 0 0 auto;
  min-width: 12.5rem;
  width: max-content;
  order: 3;

  button {
    margin-left: 5px;
  }

  @media (max-width: 650px) {
    order: 4;
    width: 100%;

    button {
      margin-left: 0;
      margin-top: 5px;
    }
  }
`;

export const InsuredValueInputLabel = styled.span`
  flex-shrink: 0;
  width: 10.4rem;
  font-size: ${FontSizes.normal};
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.input.labelColor};

  @media (max-width: 650px) {
    width: auto;
  }
`;

export const InsuredValueField = styled.div<{ $error?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
  width: 12.5rem;
  height: 4rem;
  border: 1px solid
    ${({ $error, theme }) =>
      $error
        ? theme.colors.input.errorBorderColor
        : theme.colors.baseColors.grey50};
  border-radius: 10px;
  padding: 1rem 1.6rem;
  background-color: #fff;

  &:focus-within {
    border-color: ${({ $error, theme }) =>
      $error
        ? theme.colors.input.errorBorderColor
        : theme.colors.input.borderColorFocus};
  }

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const InsuredValueInput = styled.input`
  width: 100%;
  min-width: 0;
  border: none;
  padding: 0;
  outline: none;
  font-size: ${FontSizes.medium};
  font-family: inherit;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
  background-color: #fff;

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    background-color: transparent;
    cursor: default;
    opacity: 1;
  }

  @media screen and (min-width: 768px) {
    font-size: ${FontSizes.normal};
  }
`;

export const InsuredValueCurrencyCode = styled.span`
  flex-shrink: 0;
  font-size: ${FontSizes.normal};
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
`;

export const InsuredValueMessage = styled.div`
  flex-shrink: 0;
  flex-basis: 100%;
  max-width: 40rem;
  order: 4;

  @media (max-width: 650px) {
    order: 3;
    flex-shrink: 1;
    max-width: 100%;
  }
`;

export const TitleText = styled.span`
  font-size: ${FontSizes.medium};
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.5px;
`;

export const TitleAndTag = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
`;

export const FullInsuranceValue = styled.span`
  font-weight: 700;
  font-style: Bold;
  font-size: ${FontSizes.medium};
  line-height: 22px;
  letter-spacing: 0.5px;
`;

export const BasicInsuranceTitle = styled.div`
  display: flex;
  gap: 3px;
`;

export const InfoText = styled(TitleText)`
  color: ${({ theme }) => theme.colors.baseColors.grey80};
`;
